import React, { memo, useCallback, useState } from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'
import UserModal from '../../users/selectUserModal'
import StandardModal from '../../standard/selectStandardModal'
import useAreaStore from '../areaStore'
import { useBindLevel } from './utils'

const bindTypeComponents = {
  user: UserModal,
  standard: StandardModal,
}

const BindModal = function ({ isMulti, children }) {
  const clickedId = useTbViewStore((state) => state.clickedInfo.clickedId)
  const selectedIds = useTbViewStore((state) => state.selectedIds)
  const [selectedUserList, setSelectedUserList] = useState([])
  const { setBindedList, bindedIdsMap, areaBindType } = useAreaStore((state) =>
    pick(state, ['setBindedList', 'bindedIdsMap', 'areaBindType'])
  )

  const onOpen = useCallback(() => {
    setSelectedUserList(bindedIdsMap[clickedId] || [])
  }, [bindedIdsMap, clickedId])

  const onClose = useCallback(() => {
    setSelectedUserList([])
  }, [])

  const onConfirm = useCallback(
    (list) => {
      setBindedList(isMulti ? selectedIds : clickedId, list)
    },
    [isMulti, selectedIds, clickedId]
  )

  const levelType = useBindLevel()

  const Modal = bindTypeComponents[areaBindType]

  return (
    <Modal
      trigger={children}
      onOpen={onOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      value={selectedUserList}
      levelType={levelType}
    />
  )
}

export default memo(BindModal)
